import * as RestApi from 'core/network/RestApi';
import { Site } from 'sections/client-management/entities';
import { SiteEndpoints } from './api-endpoints';
import { generatePath } from 'react-router';

export const siteQuery = async (siteId: string): Promise<Site> => {
  const result = await RestApi.get<Site>(generatePath(SiteEndpoints.GET_SITE, { siteId }));
  return result?.data;
};
